import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["selected", "options", "input"];

  connect() {
    this.dropdownElement = this.element.classList.contains("custom-dropdown")
      ? this.element
      : this.element.querySelector(".custom-dropdown") || this.element;
    if (this.hasInputTarget && this.inputTarget.value) {
      this.updateSelectedText(this.inputTarget.value);
    }

    this.boundHandleOutsideClick = this.handleOutsideClick.bind(this);
    document.addEventListener("click", this.boundHandleOutsideClick);
    
    // 옵션 컨테이너에 이벤트 위임 적용 (데이터 속성 활용)
    this.optionsTarget.addEventListener("click", (event) => {
      const option = event.target.closest('[data-dropdown-option]');
      if (option) {
        this.select(event, option);
      }
    });
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleOutsideClick);
  }

  toggle(event) {
    if (this.isReadonly()) {
      return;
    }
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    if (this.isOpen()) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  select(event, option = null) {
    if (this.isReadonly()) {
      return;
    }
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    // 이벤트 위임 방식에서는 옵션을 파라미터로 받을 수 있음
    const element = option || event.currentTarget;
    const value = element.dataset.value;
    const text = element.textContent.trim();
    
    this.selectedTarget.textContent = text;
    
    if (this.hasInputTarget) {
      const prevValue = this.inputTarget.value;
      
      this.inputTarget.value = value;
      
      if (this.inputTarget.value !== value) {
        this.inputTarget.setAttribute('value', value);
      }
      
      if (prevValue !== value) {
        const customEvent = new CustomEvent('dropdown:change', { 
          bubbles: true, 
          detail: { value, text, prevValue } 
        });
        
        const changeEvent = new Event('change', { bubbles: true });
        
        this.inputTarget.dispatchEvent(customEvent);
        this.inputTarget.dispatchEvent(changeEvent);
        
        setTimeout(() => {
          const form = this.element.closest('form');
          if (form) {
            const conflictTypeField = form.querySelector('input[name="conflict_resolution[user_selected_conflict_type]"]');
            
            if (conflictTypeField && !conflictTypeField.value && this.inputTarget.name === 'conflict_resolution[user_selected_conflict_type]') {
              conflictTypeField.value = value;
              
              const fieldChangeEvent = new Event('change', { bubbles: true });
              conflictTypeField.dispatchEvent(fieldChangeEvent);
            }
          }
        }, 100);
      }
    }
    
    this.closeDropdown();
  }

  closeDropdown() {
    this.dropdownElement.classList.remove("custom-dropdown--open");
  }

  openDropdown() {
    this.dropdownElement.classList.add("custom-dropdown--open");
  }

  isOpen() {
    return this.dropdownElement.classList.contains("custom-dropdown--open");
  }

  updateSelectedText(value) {
    const option = this.element.querySelector(`[data-dropdown-option][data-value="${value}"]`);
    if (option) {
      this.selectedTarget.textContent = option.textContent.trim();
    }
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target) && this.isOpen()) {
      this.closeDropdown();
    }
  }

  isReadonly() {
    return this.element.dataset.customDropdownReadonly === "true";
  }
}
